/**
 * Created by sasik on 11/18/15.
 */


var CurrentCategoryId = null;

var MultilevelSelect = {

    /**
     * number of rows of select
     */
    size : 4,

    /**
     * Input_name[language] for form
     */
    defaultLanguage: 'de',

    onSelectChangeCallback: function(select){
        var $this = $(this);
        var selectedCategoryId = $this.val();
        console.log(selectedCategoryId);
        $("button[type=submit]").prop("disabled",true);

        console.log($this.parent().parent().nextAll().remove());
        getChildCategories(selectedCategoryId, MultilevelSelect.takeChildCategoriesCallback, $this);
        var ProductId=$("#product_id").text();
        ProductProperties.getProperties(selectedCategoryId,ProductId);
        CurrentCategoryId = selectedCategoryId;
    },

    takeChildCategoriesCallback : function (categories, $wherePlaced) {
        console.log('takeChildCategoriesCallback');
        console.log(categories);
        

        if (categories.length < 1) {
            $("button[type=submit]").prop("disabled",false);
            return;
        }
        var $newBlock = $('<div class="col-xs-4"></div>');
        var $newSelect = $('<select name="category_id[' + MultilevelSelect.defaultLanguage + ']" class="multilevelselect form-control" size="' + MultilevelSelect.size + '"></select>').appendTo($newBlock);

        categories.forEach(function (item, i) {
            //console.log(item);
            $newSelect.append('<option value="' + item.id + '">' + item.name_default + ' '+ (item.piblished?"":LANGUAGE['main.draftcat']) + '</option>');
        });

        $newSelect.niceselect=new NiceSelect($newSelect[0]);

        $newSelect.on('change', this.onSelectChangeCallback);

        $wherePlaced.parent().parent().after($newBlock);
    }
};


function getChildCategories(id, doneCallback, $parentSelect) {
    $.ajax({
        url: '/frontend/api/category/childs/' + id,
        data : {
            _token: Sasik.getToken(),
        },
        success: function (data) {
            doneCallback(data.data, $parentSelect);
        }
    });
}


$(document).on('change', '.multilevelselect', MultilevelSelect.onSelectChangeCallback);
